import React from 'react';
import FormContainer from './FormContainer';
import './App.css';

function App() {
  return(
    <FormContainer />
  )
}

export default App;
